import React from 'react';

var ChatActions = function (_a) {
    var isMobile = _a.isMobile, isArrow = _a.isArrow, giphyOpened = _a.giphyOpened, setGiphyOpened = _a.setGiphyOpened, giphyButtonRef = _a.giphyButtonRef, emojiButtonRef = _a.emojiButtonRef, emojiPickerOpened = _a.emojiPickerOpened, handleMessageSend = _a.handleMessageSend, isTypingNotAllowed = _a.isTypingNotAllowed, setEmojiPickerOpened = _a.setEmojiPickerOpened;
    return (React.createElement("div", { className: 'chat-quick-messages-actions' },
        React.createElement("div", { className: 'chat-actions' },
            React.createElement("button", { className: 'chat-gif', ref: giphyButtonRef, onClick: function () {
                    emojiPickerOpened && setEmojiPickerOpened(false);
                    setGiphyOpened(!giphyOpened);
                } },
                React.createElement("i", { className: 'ui-lib-gif' })),
            ((isTypingNotAllowed && isMobile) || !isMobile) && (React.createElement("button", { ref: emojiButtonRef, className: "chat-emojies  ".concat(emojiPickerOpened ? 'active' : ''), onClick: function () {
                    giphyOpened && setGiphyOpened(false);
                    setEmojiPickerOpened(!emojiPickerOpened);
                } },
                React.createElement("span", { className: 'chat-emojie type-1' }),
                React.createElement("span", { className: 'chat-emojie type-2' }),
                React.createElement("span", { className: 'chat-emojie type-3' }))),
            isArrow && React.createElement("button", { className: 'chat-action', type: 'button', onClick: handleMessageSend }))));
};

export { ChatActions as default };
